import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import './index-e29b327a.js';
import { e as setNonceToElement } from './helpers-e12aa36b.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';

const bazaarVoiceRatingCss = ".bv__rating{padding-top:10px;box-sizing:border-box;display:block}.bv__rating *,.bv__rating *::before,.bv__rating *::after{box-sizing:inherit}";

const BazaarVoiceRating = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productId = undefined;
    this.bazaarVoiceInfo = undefined;
    this.isError = false;
  }
  loadBVScript() {
    var _a;
    const script = document.createElement('script');
    script.src = (_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.scriptUrl;
    script.async = true;
    script.onerror = () => (this.isError = true);
    setNonceToElement(script);
    document.head.appendChild(script);
  }
  componentWillLoad() {
    var _a;
    if ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) {
      this.loadBVScript();
    }
  }
  render() {
    var _a;
    const configured = ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) && !this.isError;
    return (configured && (h(Host, { class: "bv__rating" }, h("div", { class: "product-description__special-review-section" }, h("div", { "data-bv-show": "rating_summary", "data-bv-product-id": this.productId }), h("input", { type: "hidden", id: "bazaarVoiceHidden", value: "true" })))));
  }
};
BazaarVoiceRating.style = bazaarVoiceRatingCss;

export { BazaarVoiceRating as bazaar_voice_rating };
